import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { RepayAchPage } from './repay-ach.page';

const routes: Routes = [
  {
    path: '',
    component: RepayAchPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RepayAchPageRoutingModule {}